import React, { Component } from 'react'
import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DynamicElement from 'shared/components/DynamicElement'

const TypographyTitle = styled(Typography)`
  font-family: Lato;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`;

const TypographyDescription = styled(Typography)`
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.88;
  letter-spacing: 0.96px;
  text-align: left;
  color: #f8f9fa;
`;

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
        background: 'transparent',
        color: '#f8f9fa',
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
        padding: 0,
        borderBottom: 'solid 1px #b6b8bc',
        minHeight: '50px !important',
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
        paddingBottom: 0,
        marginBottom: '0 !important',
    },
    expanded: {},
    expandIcon: {
        color: '#f8f9fa',
        paddingBottom: '0 !important',
        paddingTop: '0 !important',
        marginBottom: -20,
    }
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: 0,
        paddingTop: 20,
    },
}))(MuiAccordionDetails);

function CustomizedAccordions() {
    const [expanded, setExpanded] = React.useState('panel0');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div style={{ maxWidth: 764, margin: '0 auto' }}>
            <DynamicElement id="6022e6bcd9747ec584d37603">
                {({ value }) => value.map((item, i) => <Accordion square expanded={expanded === 'panel' + i} onChange={handleChange('panel' + i)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <TypographyTitle><span dangerouslySetInnerHTML={{ __html: item.title }} /></TypographyTitle>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TypographyDescription>
                            <span dangerouslySetInnerHTML={{ __html: item.content }} />
                        </TypographyDescription>
                    </AccordionDetails>
                </Accordion>)}
            </DynamicElement>
        </div>
    );
}

const Heading = styled.h1`
    font-family: MinionPro-Disp;
    font-size: 100px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0;
    letter-spacing: normal;
    text-align: center;
    color: #313438;
    margin-top: 45px;

    @media (max-width: 600px){
        font-size: 55px;
        line-height: 1.18;
    }
`;


export default class TermsAndConditions extends Component {

    componentDidMount() {
        const { selectTAndCs = () => { } } = this.props;
        selectTAndCs();
    }

    render() {
        return (
            <div style={{ backgroundColor: "#121416", position: 'relative', paddingLeft: 40, paddingRight: 40 }}>
                <div className="lg-p-top lg-p-bottom">
                    <Heading>
                        <DynamicElement id="6022e43dd9747ec584d37602">
                            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                        </DynamicElement>
                    </Heading>
                    <CustomizedAccordions />
                </div>
            </div>
        )
    }
}
